import React, { useEffect, useState } from 'react';
import { Modal, Table, Button } from 'react-bootstrap';
import { PrediosPrograma, turnoMap, UserByDistance } from '../../../../../service/types/types';
import { PrediosService } from '../../../../../service/predios.service';
import { PlusCircleFill, XCircleFill } from "react-bootstrap-icons";



type Props = {
  predio: PrediosPrograma;
  onAddUser: (predio: PrediosPrograma, user: UserByDistance, turno: string) => void;
  onRemoveUser: (predio: PrediosPrograma, user: UserByDistance, turno: string) => void;
  trabajadorPredio: Map<string,string>;
  turno: string;
};

export default function UsuariosCercanosProgramaModal({predio, onAddUser, onRemoveUser, trabajadorPredio, turno}:Props) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [users, setUsers] = useState<UserByDistance[]>([]);

    useEffect(() => {
        if (!show) return;
        const fetchUsers = async () => {
            try {
                const data = await PrediosService.getClosestUsers(predio.id, turno, trabajadorPredio);
                setUsers(data);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchUsers();
    }, [show]);
  return (
    <>
        <Button
            size="sm"
            variant="outline-success"
            className="rounded-circle d-flex align-items-center justify-content-center me-2"
            style={{ width: "32px", height: "32px" }}
            onClick={handleShow}
            >
            <PlusCircleFill size={16} />
        </Button>
        
        <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
            <Modal.Title>Usuarios Cercanos</Modal.Title>
        </Modal.Header>
       <Modal.Body>
        <Table bordered responsive className="align-middle">
            <thead className="table-light">
            <tr>
                <th>RUT</th>
                <th>Nombre</th>
                <th>Teléfono</th>
                <th>Localidad</th>
                <th>Distancia (km)</th>
                <th>Turno</th>
                <th>Añadir</th>
            </tr>
            </thead>
            <tbody>
            {users.map((u) => {
                let isInPredio;
                if (turno === "M") isInPredio = predio.usersM?.some((user) => user.rut === u.rut);
                if (turno === "T") isInPredio = predio.usersT?.some((user) => user.rut === u.rut);
                if (turno === "N") isInPredio = predio.usersN?.some((user) => user.rut === u.rut);

                const isAlreadySelected = trabajadorPredio.get(u.rut);

                return (
                <tr key={u.rut} className={isInPredio ? "table-success" : ""}>
                    <td>{u.rut}</td>
                    <td>{u.name}</td>
                    <td>{u.phone}</td>
                    <td>{u.localidad}</td>
                    <td>{u.distance?.toFixed(2)}</td>
                    <td>{turnoMap[u.turno] ?? u.turno}</td>
                    {isAlreadySelected && !isInPredio ? (
                    <td className="text-muted">ya seleccionado ({isAlreadySelected})</td>
                    ) : (
                    <td>
                        {isInPredio ? (
                        <Button
                            variant="outline-danger"
                            size="sm"
                            className="rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "32px", height: "32px" }}
                            onClick={() => onRemoveUser(predio, u, turno)}
                        >
                            <XCircleFill size={16} />
                        </Button>
                        ) : (
                        <Button
                            variant="outline-success"
                            size="sm"
                            className="rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "32px", height: "32px" }}
                            onClick={() => onAddUser(predio, u, turno)}
                        >
                            <PlusCircleFill size={16} />
                        </Button>
                        )}
                    </td>
                    )}
                </tr>
                );
            })}
            </tbody>
        </Table>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
            Cerrar
            </Button>
        </Modal.Footer>
        </Modal>
    </>
  );
}